// Full Bench — What's new announcements (edit this list when you ship updates).
// Newest first. Keep entries short and human — 1 sentence lead-in + optional bullets.
// `id` must be stable per post; users can collapse the whole panel via localStorage.

const ANNOUNCEMENTS = [
  {
    id: "2026-02-projects-redesign",
    date: "2026-02-17",
    tag: "New",
    title: "Projects, redesigned",
    body: "A fresh Projects hub grouped by client with pinned/archived views, row-level actions (Pin · Duplicate · Archive · Delete), CSV export, and a per-project dashboard with a cumulative spend chart, 5 KPI cards, and Tasks / Team / Invoices tabs.",
  },
  {
    id: "2026-02-csv-imports",
    date: "2026-02-16",
    tag: "New",
    title: "CSV imports for six entity types",
    body: "Bring your data across from another platform without retyping. Import Clients, Projects (with opening balances), Team (with rates), Tasks, Roles and Departments in a 3-step wizard from /app/import.",
  },
  {
    id: "2026-02-permissions-tab",
    date: "2026-02-15",
    tag: "Update",
    title: "Team member permissions",
    body: "Assign one of six permission profiles (Member, Project Manager, People Admin, Accounting, Executive Manager, Administrator) from the member profile drawer.",
  },
];

export default ANNOUNCEMENTS;
